export const NotificationManager = {
    async requestPermission() {
      if (!("Notification" in window)) {
    
        return false;
      }
  
      try {
        const permission = await Notification.requestPermission();
        return permission === "granted";
          } catch (error) {
        return false;
      }
    },
  
    async enableNotifications() {
      const permissionGranted = await this.requestPermission();
      if (!permissionGranted) {
        return false;
      }
      return true;
    },
  
    disableNotifications() {
      // You can't revoke notification permissions via JavaScript,
      // but you can stop showing notifications by updating the Redux state
      return true;
    }
  };